import { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Appbar, Snackbar, Footer } from '@carcareers/components';

export interface DefaultShellProps {
  children?: ReactNode;
}

export const DefaultShell: FC<DefaultShellProps> = ({ children }) => {
  return (
    <>
      <Appbar />
      <Box
        sx={{
          minHeight: { xs: 'calc(100vh - 160px)', sm: 'calc(100vh - 132px)' },
          backgroundColor: 'background.default',
          mt: { xs: 7, sm: 8 },
        }}
      >
        <Snackbar />
        {children}
        <Outlet />
      </Box>
      <Footer />
    </>
  );
};

export default DefaultShell;
